/* src/app/components/home/home.component.css */
.inlineParagraph {
  display: inline-block;
  vertical-align: top;
  text-align: justify;
  color: var(--danger);
  cursor: pointer;
  background: var(--gray-100);
  padding: 5px;
  border: 1px solid var(--navy-100);
  border-radius: 3px;
}
.inlineParagraphFinished {
  display: inline-block;
  vertical-align: top;
  text-align: justify;
  color: var(--success);
  cursor: pointer;
  background: var(--gray-100);
  padding: 5px;
  border: 1px solid var(--navy-100);
  border-radius: 3px;
}
.underlinedInlineParagraph {
  display: inline-block;
  vertical-align: top;
  text-decoration: line-through;
  text-align: justify;
  color: var(--navy-500);
  cursor: pointer;
  background: var(--gray-100);
  padding: 5px;
  border: 1px solid var(--navy-100);
  border-radius: 3px;
}
.timeStatusParagraph {
  display: inline-block;
  vertical-align: top;
  text-align: justify;
  color: var(--fg-3);
  cursor: pointer;
  text-decoration: overline;
}
table.fixed {
  table-layout: fixed;
  width: 100%;
}
.table-wrapper {
  width: 100%;
  height: 550px;
  overflow: auto;
}
.chart-width {
  width: 45%;
}
.right-separator {
  margin-right: 4%;
}
.dashboard-nav {
}
.carousel-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.carousel-controls button {
  padding: 4px 12px;
  cursor: pointer;
}
.carousel-controls button:disabled {
  opacity: 0.4;
  cursor: default;
}
ng-select {
  min-width: 350px;
}
/*# sourceMappingURL=home.component.css.map */
